<template>
  <div class="p-tab-nav">
    <button
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      class="p-tab-nav__item"
      :class="{ 'is-active': modelValue === tab.id }"
      @click="$emit('update:modelValue', tab.id)"
    >
      <i class="material-icons-round">{{ tab.icon }}</i>
      <span>{{ tab.label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "TabNav",
  props: {
    modelValue: { type: String, required: true },
    tabs: { type: Array, required: true, default: () => [] },
  },
  emits: ["update:modelValue"],
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.p-tab-nav {
  display: inline-flex;
  background: $p-panel;
  border: 1px solid $p-line;
  border-radius: $p-radius-md;
  padding: 4px;
  gap: 2px;

  &__item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border: 0;
    background: transparent;
    color: $p-ink-mid;
    font-family: $p-font-body;
    font-size: 13px;
    font-weight: 700;
    border-radius: $p-radius;
    cursor: pointer;
    transition: background $p-dur $p-ease, color $p-dur $p-ease;

    > i { font-size: 16px; }

    &:hover {
      background: $p-panel-alt;
      color: $p-ink;
    }

    &.is-active {
      background: $p-ink;
      color: $p-point;
    }
  }
}
</style>
